import { render, staticRenderFns } from "./QueenslandForms.vue?vue&type=template&id=4ab80081&scoped=true&"
import script from "./QueenslandForms.vue?vue&type=script&lang=ts&"
export * from "./QueenslandForms.vue?vue&type=script&lang=ts&"
import style0 from "./QueenslandForms.vue?vue&type=style&index=0&id=4ab80081&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab80081",
  null
  
)

export default component.exports